window.TABS = window.TABS || {};

window.createAnalyticsEvent = function (eventName) {
    return new Event(eventName);
}

window.TABS.analytics = {
    getBrandEventName: function () {
        if (typeof window.branding !== 'undefined') {
            return window.branding.toLowerCase() + ':api';
        }
        return 'tabs:api'
    },
    triggerAnalyticsEvent: function (endpointName, action, label, value) {
        if (typeof window.dispatchEvent !== 'function') {
            return;
        }
        const brandEventName = this.getBrandEventName();
        const event = createAnalyticsEvent(brandEventName);
        event.analytics = {
            type: 'event',
            endpoint: endpointName,
            category: brandEventName,
            action: action
        };
        if (label) {
            event.analytics.label = label;
        }
        if (typeof value !== 'undefined') {
            event.analytics.value = value;
        }
        if (window.self !== window.top) {
            window.top.postMessage({
                eventName: brandEventName,
                analytics: event.analytics,
            }, '*');
            return;
        }
        window.dispatchEvent(event);
    },
    triggerPurchaseEvent: function (payload) {
        if (typeof window.fbq !== 'undefined') {
            window.fbq('track', 'Purchase', { currency: TABS.$t('NOK'), value: payload.value });
        }
        if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'purchase', payload);
        }

        if (typeof window.dispatchEvent !== 'function') {
            return;
        }
        const brandEventName = this.getBrandEventName();

        const event = createAnalyticsEvent(brandEventName + ':purchase');
        event.analytics = payload;

        if (window.self !== window.top) {
            window.top.postMessage({
                eventName: brandEventName + ':purchase',
                analytics: event.analytics,
            }, '*');
            return;
        }
        window.dispatchEvent(event);
    },
}